<template>
    <div class="probenplan-detail">
        <FormGroupBuilder
            :fields="fields"
            :data="localData"
            :refresh="validationRefresh"
            ref="fgb"
        >
            <template v-slot:additionalContent(info)="{ data: key }">
                <p class="my-1">
                    <b-button
                        v-if="checkRight('delete')"
                        variant="danger"
                        size="sm"
                        :disabled="fields[key].meta.suggestionDeleteButton.busy"
                        @click="deleteSuggestion(key)"
                    >
                        <template
                            v-if="fields[key].meta.suggestionDeleteButton.busy"
                        >
                            <Spinner small variant="light" />
                        </template>
                        <template v-else>Vorlage löschen</template>
                    </b-button>
                    <b-button
                        v-if="checkRight('write')"
                        class="ml-auto float-right"
                        :variant="fields[key].meta.suggestionButton.variant"
                        :disabled="
                            fields[key].meta.suggestionButton.disabled ||
                                fields[key].meta.suggestionButton.busy
                        "
                        size="sm"
                        @click="provideSuggestion(key)"
                    >
                        <template v-if="fields[key].meta.suggestionButton.busy">
                            <Spinner small variant="light" />
                        </template>
                        <template v-else>{{
                            fields[key].meta.suggestionButton.text
                        }}</template>
                    </b-button>
                </p>
            </template>

            <template v-slot:additionalContent(ort)="{ data: key }">
                <p class="my-1">
                    <b-button
                        v-if="checkRight('delete')"
                        variant="danger"
                        size="sm"
                        :disabled="fields[key].meta.suggestionDeleteButton.busy"
                        @click="deleteSuggestion(key)"
                    >
                        <template
                            v-if="fields[key].meta.suggestionDeleteButton.busy"
                        >
                            <Spinner small variant="light" />
                        </template>
                        <template v-else>Vorlage löschen</template>
                    </b-button>
                    <b-button
                        v-if="checkRight('write')"
                        class="ml-auto float-right"
                        :variant="fields[key].meta.suggestionButton.variant"
                        :disabled="
                            fields[key].meta.suggestionButton.disabled ||
                                fields[key].meta.suggestionButton.busy
                        "
                        size="sm"
                        @click="provideSuggestion(key)"
                    >
                        <template v-if="fields[key].meta.suggestionButton.busy">
                            <Spinner small variant="light" />
                        </template>
                        <template v-else>{{
                            fields[key].meta.suggestionButton.text
                        }}</template>
                    </b-button>
                </p>
            </template>

            <template v-slot:additionalContent(notiz)="{ data: key }">
                <p class="my-1">
                    <b-button
                        v-if="checkRight('delete')"
                        variant="danger"
                        size="sm"
                        :disabled="fields[key].meta.suggestionDeleteButton.busy"
                        @click="deleteSuggestion(key)"
                    >
                        <template
                            v-if="fields[key].meta.suggestionDeleteButton.busy"
                        >
                            <Spinner small variant="light" />
                        </template>
                        <template v-else>Vorlage löschen</template>
                    </b-button>
                    <b-button
                        v-if="checkRight('write')"
                        class="ml-auto float-right"
                        :variant="fields[key].meta.suggestionButton.variant"
                        :disabled="
                            fields[key].meta.suggestionButton.disabled ||
                                fields[key].meta.suggestionButton.busy
                        "
                        size="sm"
                        @click="provideSuggestion(key)"
                    >
                        <template v-if="fields[key].meta.suggestionButton.busy">
                            <Spinner small variant="light" />
                        </template>
                        <template v-else>{{
                            fields[key].meta.suggestionButton.text
                        }}</template>
                    </b-button>
                </p>
            </template>
        </FormGroupBuilder>
    </div>
</template>

<script>
import Validation from "@/mixins/Validation/Validation";
import Rights from "@/mixins/Rights/Rights";

import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";
import Spinner from "@/components/Spinner/Spinner";

import { ApiFactory } from "@/api/ApiFactory";
const ProbenplanApi = ApiFactory.get("probenplan");
const WerkeApi = ApiFactory.get("werke");

export default {
    name: "ProbenplanDetail",
    mixins: [Validation, Rights],
    components: {
        FormGroupBuilder,
        Spinner
    },
    props: ["value", "probentypen", "validationResponse", "parentRights"],
    data() {
        return {
            fields: {
                id: {
                    key: "id",
                    label: "ID",
                    disabled: true,
                    oneWay: true
                },
                datum: {
                    key: "datum",
                    label: "Tag",
                    type: "date",
                    mandatory: true
                },
                full_day: {
                    key: "full_day",
                    label: "ganztägig",
                    type: "checkbox",
                    mandatory: true
                },
                start: {
                    key: "start",
                    label: "Uhrzeit (ab)",
                    type: "time",
                    // mode: "autocomplete",
                    // api: ProbenplanApi,
                    // apiType: "zeit",
                    mandatory: true,
                    placeholder: "z.B. 19:00"
                },
                end: {
                    key: "end",
                    label: "Uhrzeit (bis)",
                    type: "time",
                    // mode: "autocomplete",
                    // api: ProbenplanApi,
                    // apiType: "zeit",
                    mandatory: false,
                    placeholder: "z.B. 21:00",
                    description:
                        "Wenn keine Ende des Termins eingetragen wird, wird der Termin mit einer zweistündigen Dauer vermerkt"
                },
                seperator_probe: {
                    type: "hr",
                    label: "Probeninformationen",
                    labelBold: true
                },
                pk_typ: {
                    key: "pk_typ",
                    label: "Probentyp",
                    type: "select",
                    options: this.probentypen,
                    mandatory: true,
                    description:
                        "Wenn ein Probentyp gewählt ist wird die Veranstaltung als Probe für das angegebene Werk gewertet. Außerdem sind die Informationen für die Pflichtprobenkontrolle und Gastsängerabrechnung relevant"
                },
                werk_id: {
                    key: "werk_id",
                    label: "Werk aus Stammdaten",
                    type: "select",
                    disabled: true,
                    options: [],
                    placeholder: "Werk auswählen...",
                    description: "Werkszuordnung zum Probentermin"
                },
                stimmen: {
                    key: "stimmen",
                    label: "zugeordnete Stimmen",
                    type: "checkboxgroup",
                    disabled: true,
                    handler: {
                        change: val => {
                            ["sopran", "alt", "tenor", "bass"].forEach(
                                stimme => {
                                    this.localData[stimme] = 0;
                                }
                            );
                            val.forEach(stimme => {
                                this.localData[stimme] = 1;
                            });
                        }
                    },
                    options: [
                        {
                            value: "sopran",
                            text: "Sopran"
                        },
                        {
                            value: "alt",
                            text: "Alt"
                        },
                        {
                            value: "tenor",
                            text: "Tenor"
                        },
                        {
                            value: "bass",
                            text: "Bass"
                        }
                    ]
                },
                seperator_meta: {
                    type: "hr",
                    label: "Zusatzinformationen",
                    labelBold: true
                },
                info: {
                    key: "info",
                    label: "Info",
                    placeholder: "z.B. Tag der Arbeit",
                    description:
                        "Beschreibung der Veranstaltung, hier können auch Ergänzungen zu Proben vermerkt werden",
                    mode: "predefined",
                    api: ProbenplanApi,
                    apiType: "info",
                    meta: {
                        suggestionButton: {
                            variant: "secondary",
                            text: "Als Vorlage speichern",
                            disabled: false,
                            busy: false
                        },
                        suggestionDeleteButton: {
                            busy: false
                        }
                    }
                },

                ort: {
                    key: "ort",
                    label: "Ort",
                    placeholder: "z.B. Tonhalle",
                    description: "Ort der Veranstaltung",
                    mode: "predefined",
                    api: ProbenplanApi,
                    apiType: "ort",
                    meta: {
                        suggestionButton: {
                            variant: "secondary",
                            text: "Als Vorlage speichern",
                            disabled: false,
                            busy: false
                        },
                        suggestionDeleteButton: {
                            busy: false
                        }
                    }
                },
                notiz: {
                    key: "notiz",
                    label: "Notiz",
                    type: "textarea",
                    mode: "predefined",
                    placeholder: "z.B. Bitte Noten unbedingt mitbringen",
                    description:
                        "Längere Zusatzinformationen zu einer Veranstaltung",
                    // mode: "autocomplete",
                    api: ProbenplanApi,
                    apiType: "notiz",
                    meta: {
                        suggestionButton: {
                            variant: "secondary",
                            text: "Als Vorlage speichern",
                            disabled: false,
                            busy: false
                        },
                        suggestionDeleteButton: {
                            busy: false
                        }
                    }
                },
                farbe: {
                    key: "farbe",
                    label: "Farbe",
                    description:
                        "Anzeigefarbe der Veranstaltung. Wenn keine Farbe gewählt wird, erscheint der Termin in schwarzer Schrift im Probenplan",
                    type: "select",
                    options: [
                        {
                            value: null,
                            text: "Bitte Farbe auswählen..."
                        },
                        {
                            value: "000000",
                            text: "schwarz"
                        },
                        {
                            value: "FF0000",
                            text: "rot"
                        },
                        {
                            value: "0000FF",
                            text: "blau"
                        },
                        {
                            value: "006600",
                            text: "grün"
                        }
                    ]
                }
            },
            localData: this.value,
            refresh: false,
            defaultSuggestionButton: {
                variant: "secondary",
                text: "Als Vorlage speichern",
                disabled: false,
                busy: false
            }
        };
    },
    created() {
        if (!this.localData.id) {
            this.localData.pk_typ = 1;
        }
        this.reRegisterRights(this.parentRights);
        this.fetchWerke();
    },
    watch: {
        localData: {
            handler(val) {
                this.$emit("input", val);
            },
            deep: true
        },
        "localData.full_day": {
            handler(val) {
                if (val) {
                    this.fields.start.mandatory = false;
                    this.fields.start.disabled = true;
                    this.fields.start.description =
                        "Dieses Feld wird nur genutzt, wenn der Termin nicht ganztägig ist.";
                    this.fields.end.disabled = true;
                } else {
                    this.fields.start.mandatory = true;
                    this.fields.start.disabled = false;
                    this.fields.start.description = "";
                    this.fields.end.disabled = false;
                }
            },
            immediate: true
        },
        "localData.pk_typ": {
            handler(val) {
                var stimmen = [];
                if (val !== null) {
                    if (
                        typeof this.localData.stimmen === "undefined" ||
                        this.localData.stimmen === null
                    ) {
                        stimmen = ["sopran", "alt", "tenor", "bass"];
                        stimmen.forEach(stimme => {
                            this.localData[stimme] = 1;
                        });
                        this.localData.stimmen = stimmen;
                    }
                    this.fields.werk_id.disabled = false;
                    this.fields.werk_id.mandatory = true;
                    this.fields.stimmen.disabled = false;
                } else {
                    ["sopran", "alt", "tenor", "bass"].forEach(stimme => {
                        this.localData[stimme] = 0;
                    });
                    this.localData.stimmen = stimmen;
                    this.fields.werk_id.disabled = true;
                    this.fields.werk_id.mandatory = false;
                    this.fields.stimmen.disabled = true;
                }
            },
            immediate: true
        },
        "localData.info": {
            handler(val, oldVal) {
                if (val !== oldVal) {
                    this.fields.info.meta.suggestionButton = this.defaultSuggestionButton;
                }
            }
        },
        "localData.ort": {
            handler(val, oldVal) {
                if (val !== oldVal) {
                    this.fields.ort.meta.suggestionButton = this.defaultSuggestionButton;
                }
            }
        },
        "localData.notiz": {
            handler(val, oldVal) {
                if (val !== oldVal) {
                    this.fields.notiz.meta.suggestionButton = this.defaultSuggestionButton;
                }
            }
        },
        validationResponse: {
            handler(val) {
                this.handleValidationData(val, this.fields);
            },
            deep: true
        }
    },
    methods: {
        async fetchWerke() {
            this.fields.werk_id.options = [
                { value: null, text: "Werke werden geladen..." }
            ];

            this.fields.werk_id.disabled = true;

            const response = await WerkeApi.get();
            if (response.ok) {
                const data = response.json.collection;

                var options = [{ value: null, text: "Werke auswählen..." }];
                options = options.concat(
                    data.map(item => {
                        return {
                            value: item.id,
                            text:
                                item.bezeichnung +
                                " - " +
                                this.$moment(item.verfallsdatum)
                                    .subtract("1", "day")
                                    .format("DD.MM.Y")
                        };
                    })
                );
                this.fields.werk_id.options = options;
                this.fields.werk_id.disabled = false;
            }
        },
        async provideSuggestion(type) {
            this.fields[type].meta.suggestionButton.busy = true;
            const response = await ProbenplanApi.postSuggestion(
                type,
                this.localData[type]
            );
            this.fields[type].meta.suggestionButton.busy = false;
            if (response.ok) {
                this.fields[type].meta.suggestionButton = {
                    variant: "success",
                    text: "Vorlage gespeichert",
                    disabled: true
                };
                this.$root.$emit(
                    `mv::predefined_input::${type}::options:add`,
                    this.localData[type]
                );
            } else {
                if (response.status === 400) {
                    this.fields[type].meta.suggestionButton = {
                        variant: "warning",
                        text: "Vorlage schon vorhanden",
                        disabled: true
                    };
                } else {
                    this.fields[type].meta.suggestionButton = {
                        variant: "danger",
                        text: "Fehler beim Speichern",
                        disabled: true
                    };
                }
            }
        },
        async deleteSuggestion(type) {
            this.fields[type].meta.suggestionDeleteButton.busy = true;
            const response = await ProbenplanApi.deleteSuggestion(
                type,
                this.localData[type]
            );
            this.fields[type].meta.suggestionDeleteButton.busy = false;
            if (response.ok) {
                this.$root.$emit(
                    `mv::predefined_input::${type}::options:remove`,
                    this.localData[type]
                );
            } else {
                console.log("no");
            }
        }
    }
};
</script>
